import React from "react";
import { useSlate } from "slate-react";
import { isBlockActive, toggleBlock } from "./rich-editor-helpers";
import { isMarkActive, toggleMark } from "./rich-editor-helpers";

interface Props {
    format: string;
    icon: string;
    IsMobileDevice?: boolean;
}

interface ToolBarProps {
    IsMobileDevice?: boolean;
    children:React.ReactElement;
}

export const MarkButton: React.FC<Props> = ({ format, icon }) => {
    const editor = useSlate();
    const isActive = isMarkActive(editor, format);
    const Icon = icon
    return (
        <div
            className={isActive ? "bg-color-rich-text-active c-pointer" : "c-pointer"}
            onMouseDown={(evt) => {
                evt.preventDefault();
                toggleMark(editor, format);
            }}
        >
            <Icon />
        </div>
    );
};

export const BlockButton: React.FC<Props> = ({ format, icon }) => {
    const editor = useSlate();
    const isActive = isBlockActive(editor, format);
    const Icon = icon
    return (
        <div
            className={isActive ? "bg-color-rich-text-active c-pointer" : "c-pointer"}
            onMouseDown={(evt) => {
                evt.preventDefault();
                toggleBlock(editor, format);
            }}
        >
            <Icon />
        </div>
    );
};

export const Toolbar: React.FC<ToolBarProps> = props => {
    return (
        <div className={`toolbar-container d-flex justify-around h4-semibold ml-auto ${props.IsMobileDevice ? "w-p-100" : "w-p-50"}`}>
            {props.children}
        </div>
    );
};
